import { render, staticRenderFns } from "./HeroBlockList.vue?vue&type=template&id=a983e71e&scoped=true&"
import script from "./HeroBlockList.vue?vue&type=script&lang=js&"
export * from "./HeroBlockList.vue?vue&type=script&lang=js&"
import style0 from "./HeroBlockList.vue?vue&type=style&index=0&id=a983e71e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a983e71e",
  null
  
)

export default component.exports